import { cache } from '@/container/apollo-client/cache';
import { AssignedChannelCounter, Channel, useAssignedChannelCounterSubscription } from '@/types/generated/graphql';
import { gql } from '@apollo/client';
import { useParams } from 'react-router-dom';

const FRAGMENT_CHANNEL = gql`
  fragment ChannelCounterSubscription on Channel {
    id
    unreadCounter
  }
`;

export const useChannelCounterSubscription = () => {
  const { channelId = '', clientId = '' } = useParams();

  useAssignedChannelCounterSubscription({
    onData: (res) => {
      handleOnData({
        data: res?.data?.data?.assignedChannelCounter as AssignedChannelCounter,
        channelId,
        clientId,
      });
    },
  });
};

function handleOnData({
  data,
  channelId,
  clientId,
}: {
  data: AssignedChannelCounter;
  channelId: string;
  clientId: string;
}) {
  const isChatOpen = String(data?.channelId) === channelId && String(data?.clientId) === clientId;
  const currentCount = cache.readFragment<Pick<Channel, 'unreadCounter'> | null>({
    fragment: FRAGMENT_CHANNEL,
    id: 'Channel:' + data?.channelId + '',
  });

  // occurs when opening chat which has counter
  const isIncomingSubstracted = (currentCount?.unreadCounter ?? 0) > (data?.counter ?? 0);

  // ignore if new message on currently opened chat
  if (isChatOpen && !isIncomingSubstracted) return;

  cache.writeFragment<Channel | null>({
    fragment: FRAGMENT_CHANNEL,
    id: 'Channel:' + data?.channelId + '',
    data: {
      id: data?.channelId,
      unreadCounter: data?.counter,
    },
  });
}
